import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu as MenuIcon, X, MessageCircle } from "lucide-react";
import { SITE } from "@/data/site";

const NAV = [
  { to: "/", label: "Beranda", id: "nav-beranda" },
  { to: "/menu/", label: "Menu", id: "nav-menu" },
  { to: "/tentang/", label: "Tentang", id: "nav-tentang" },
  { to: "/lokasi/", label: "Lokasi", id: "nav-lokasi" },
  { to: "/faq/", label: "FAQ", id: "nav-faq" },
  { to: "/kontak/", label: "Kontak", id: "nav-kontak" },
];

const LogoMark = () => (
  <svg aria-hidden="true" viewBox="0 0 32 32" className="h-8 w-8 shrink-0">
    <rect width="32" height="32" rx="7" fill="#9E1B12" />
    <path
      d="M5 23 L7 17 Q10 15 13 10 Q14.5 7 16 7 Q17.5 7 19 10 Q22 15 25 17 L27 23 Z"
      fill="#F8F1E3"
    />
    <rect x="5" y="23.5" width="22" height="2" rx="1" fill="#D99323" />
  </svg>
);

const Header = () => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 border-b border-ink/10 bg-rice/95 backdrop-blur"
    >
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-4 py-3 sm:px-6">
        <Link
          to="/"
          data-testid="header-logo"
          className="flex items-center gap-2.5"
          aria-label="Beranda RM. Payakumbuah"
        >
          <LogoMark />
          <span className="leading-tight">
            <span className="block font-display text-lg font-bold text-lado">
              RM. Payakumbuah
            </span>
            <span className="block text-[11px] font-semibold uppercase tracking-[0.18em] text-ijo">
              {SITE.tagline}
            </span>
          </span>
        </Link>

        <nav aria-label="Navigasi utama" className="hidden items-center gap-1 lg:flex">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.to === "/"}
              data-testid={n.id}
              className={({ isActive }) =>
                `rounded-full px-3.5 py-2 text-sm font-semibold transition-colors hover:bg-lado/10 hover:text-lado ${
                  isActive ? "bg-lado text-rice hover:bg-lado hover:text-rice" : "text-ink"
                }`
              }
            >
              {n.label}
            </NavLink>
          ))}
          <a
            href={SITE.wa.href}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="header-wa-cta"
            className="ml-2 inline-flex items-center gap-2 rounded-full bg-ijo px-4 py-2 text-sm font-bold text-rice transition-transform hover:-translate-y-0.5"
          >
            <MessageCircle className="h-4 w-4" aria-hidden="true" />
            Pesan via WhatsApp
          </a>
        </nav>

        <button
          type="button"
          data-testid="mobile-menu-button"
          aria-expanded={open}
          aria-controls="mobile-menu"
          aria-label={open ? "Tutup menu navigasi" : "Buka menu navigasi"}
          onClick={() => setOpen((v) => !v)}
          className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-ink/15 text-ink lg:hidden"
        >
          {open ? <X className="h-5 w-5" /> : <MenuIcon className="h-5 w-5" />}
        </button>
      </div>

      {open && (
        <nav
          id="mobile-menu"
          data-testid="mobile-menu"
          aria-label="Navigasi seluler"
          className="border-t border-ink/10 bg-rice px-4 pb-5 pt-2 lg:hidden"
        >
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.to === "/"}
              data-testid={`mobile-${n.id}`}
              className={({ isActive }) =>
                `block rounded-lg px-3 py-3 text-base font-semibold ${
                  isActive ? "bg-lado text-rice" : "text-ink hover:bg-lado/10"
                }`
              }
            >
              {n.label}
            </NavLink>
          ))}
          <a
            href={SITE.wa.href}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="mobile-wa-cta"
            className="mt-2 inline-flex w-full items-center justify-center gap-2 rounded-full bg-ijo px-4 py-3 text-base font-bold text-rice"
          >
            <MessageCircle className="h-5 w-5" aria-hidden="true" />
            Pesan via WhatsApp
          </a>
        </nav>
      )}
    </header>
  );
};

export default Header;
